export default {
  clubs(state) {
    return state.clubs;
  },
  zones(state) {
    return state.zones;
  },
};
